module.exports = __webpack_public_path__ + "static/media/176.de63e162.svg";